module.exports = __webpack_public_path__ + "img/7_Hepatic--Flexure.88dd9b16.png";